import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export function useShortcuts() {
  const navigate = useNavigate();
  const lastKey = useRef<{ key: string; at: number } | null>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target instanceof HTMLSelectElement
      )
        return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const now = Date.now();
      const last = lastKey.current;
      if (last && last.key === "g" && now - last.at < 800) {
        const map: Record<string, string> = {
          h: "/",
          p: "/pipeline",
          t: "/tof",
          a: "/agents",
          s: "/prospects",
          o: "/outreach",
          r: "/revenue",
        };
        if (map[e.key]) {
          e.preventDefault();
          navigate(map[e.key]);
          lastKey.current = null;
          return;
        }
      }
      if (e.key === "g") lastKey.current = { key: "g", at: now };
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);
}
